import { Table, Container, Button, Group } from "@mantine/core";

export default function TaskTable({
  keys,
  tasks,
  deleteCallback,
  editCallback,
}) {
  return (
    <Table striped>
      <thead>
        <tr>
          {keys?.map((k, key) => {
            return <th key={key}>{k}</th>;
          })}
          {deleteCallback && <th></th>}
        </tr>
      </thead>
      <tbody>
        {tasks.map((t, key) => {
          let data = t.data();
          return (
            <tr key={key}>
              {keys?.map((k, key) => {
                if (data[k]) {
                  if (typeof data[k] === "string") {
                    return <td key={key}>{data[k]}</td>;
                  } else {
                    let t = new Date(data[k]?.seconds * 1000);
                    return <td key={key}>{t?.toLocaleDateString()}</td>;
                  }
                }
                return <td key={key}></td>;
              })}

              {deleteCallback && (
                <td style={{"width": "200px"}}>
                  <Container size={200}>
                    <Group position="apart">
                      <Button
                        size="xs"
                        color={"blue"}
                        variant="outline"
                        onClick={() => {
                          editCallback(t);
                        }}
                      >
                        Edit
                      </Button>

                      <Button
                        size="xs"
                        color={"red"}
                        variant="outline"
                        onClick={() => {
                          deleteCallback(t.id);
                        }}
                      >
                        Delete
                      </Button>
                    </Group>
                  </Container>
                </td>
              )}
            </tr>
          );
        })}
      </tbody>
    </Table>
  );
}
